import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { prepareForSlot, Button as Button$1 } from '@mui/base';
import { styled } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ButtonProvider } from './ButtonContext.js';
import { ButtonLoader } from './ButtonLoader.js';
import { CLASSES } from './classes.js';
import { getSizeStyles, getVariantStyles } from './styles.js';

const ButtonRoot = prepareForSlot(styled("button")(({ theme, $variant, $size, $color, $fullWidth, disabled, $isLoading }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", position: "relative", cursor: "pointer", fontWeight: 500, borderRadius: theme.shape.borderRadius, textDecoration: "none", verticalAlign: "middle", transition: `
      background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      outline 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
    `, padding: theme.spacing(0, 0.5), "& > *": {
        letterSpacing: "normal",
    } }, (disabled && {
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.4,
})), ($isLoading && {
    pointerEvents: "none",
})), getSizeStyles(theme, $size)), getVariantStyles(theme, $variant, $color)), ($fullWidth && {
    minWidth: "100%",
})))));
const ButtonContent = styled("div")(({ $isLoading }) => (Object.assign({ display: "flex", alignItems: "center" }, ($isLoading && {
    visibility: "hidden",
}))));
const ButtonComponent = forwardRef(function ButtonComponent(_a, ref) {
    var { disabled, isLoading = false, children, component, variant = "default", color = "primary", size = "md", fullWidth, className } = _a, rest = __rest(_a, ["disabled", "isLoading", "children", "component", "variant", "color", "size", "fullWidth", "className"]);
    return (jsx(ButtonProvider, { color: color, isDisabled: disabled, isLoading: isLoading, size: size, variant: variant, children: jsxs(Button$1, Object.assign({ "$color": color, "$fullWidth": fullWidth, "$isLoading": isLoading, "$size": size, "$variant": variant, as: component, disabled: disabled, ref: ref, slots: {
                root: ButtonRoot,
            } }, rest, { className: clsx(CLASSES.wrapper, className), children: [isLoading && jsx(ButtonLoader, {}), jsx(ButtonContent, { "$isLoading": isLoading, children: children })] })) }));
});
const Button = ButtonComponent;

export { Button, ButtonRoot };
//# sourceMappingURL=Button.js.map
